import React, { useEffect, useState } from 'react'
import { getDefaultValue, getDefaultDescription, isImage } from '../../utils';
import { addParticipantToCourse, loadCourseDocument, loadCourseParticipants, loadTalentDocument, loadUserTalentDocuments } from '../../utils/Network'
import Modal from 'react-modal';
import { useStateValue } from '../../StateProvider';
import parse from 'html-react-parser'
import UserTalentDocumentUpload from '../userTalentDocumentUpload';
import ContestParticipation from './ContestParticipation';

function asParticipantList(payload) {
    return Array.isArray(payload) ? payload : [];
}

function findParticipantForCourse(list, course_id) {
    return asParticipantList(list).find((x) => {
        const cid = x?.course?.id ?? x?.course;
        return cid === course_id;
    });
}

function userTalentMatchesContest(ut, contestTalentIds) {
    if (!ut.talent || !contestTalentIds.length) return false;
    const chain =
        Array.isArray(ut.talent.ancestor_ids) && ut.talent.ancestor_ids.length
            ? ut.talent.ancestor_ids
            : [ut.talent.id];
    const chainSet = new Set(chain);
    return contestTalentIds.some((cid) => chainSet.has(cid));
}

export default function ParticipateButton({ course_id, course, usertalents,
    talent_id, unroll, setMessage }) {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [rules_error, setRulesError] = useState(null)
    const [courseParticipant, setCourseParticipant] = useState(null)
    const [courseParticipants, setCourseParticipants] = useState(null)
    const [courseDocument, setCourseDocument] = useState(null)

    const [usertalent_id, setUserTalentId] = useState(null);
    const [contestParticipationModalIsOpen, setContestParticipationModalIsOpen] = useState(null);


    const [documents, setDocuments] = useState(null);
    const [talent_document, setTalentDocument] = useState(null);



    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };



    useEffect(() => {

        const talentIdsForCourse =
            course && course.talents && course.talents.length
                ? course.talents.map((t) => (typeof t === "object" ? t.id : t))
                : talent_id
                ? [talent_id]
                : [];

        let matchedUt = null;
        if (usertalents && talentIdsForCourse.length) {
            matchedUt = usertalents.find((x) =>
                userTalentMatchesContest(x, talentIdsForCourse)
            );
            if (matchedUt) {
                setUserTalentId(matchedUt.id);
                getUserTalentDocuments(matchedUt.id);
            }
        }

        const docTalentId =
            matchedUt?.talent?.id ?? talentIdsForCourse[0] ?? talent_id;

        if (docTalentId) {
            setLoading(true);
            loadTalentDocument(docTalentId).then((document) => {
                setTalentDocument(document);
                setLoading(false);
            });
        }

        loadCourseParticipants(course_id).then(courseparticipants => {
            const list = asParticipantList(courseparticipants);
            setCourseParticipants(list)
            var courseparticipant = findParticipantForCourse(list, course_id)
            if (courseparticipant) {

                setCourseParticipant(courseparticipant)
                loadCourseDocument(course_id).then(data => {
                    if (data && data.userdocument)
                        setCourseDocument(data.userdocument.file)
                })
            }
        })
    }, [])

    const getUserTalentDocuments = (usertalent_id) => {
        if (!usertalent_id) {
            setDocuments(null)
            return;
        }

        setLoading(true)
        loadUserTalentDocuments(usertalent_id).then(documents => {
            var temp = [];
            setLoading(false)
            asParticipantList(documents).forEach((item, index) => {
                if (index < 1) {
                    item.selected = 1;
                }
                else
                    item.selected = 0;

                temp.push(item)
            })
            setDocuments(temp)
        })

        setLoading(true)

        loadCourseParticipants(course_id).then(courseparticipants => {
            const list = asParticipantList(courseparticipants);
            setCourseParticipants(list)
            setLoading(false)
            var courseparticipant = findParticipantForCourse(list, course_id)
            if (courseparticipant) {

                setCourseParticipant(courseparticipant)
                loadCourseDocument(course_id).then(data => {
                    if (data && data.userdocument)
                        setCourseDocument(data.userdocument.file)
                })
            }
        })


    }
    const setDocumentSelected = document_id => {
        var temp = [];
        documents.map((item, index) => {
            if (item.id === document_id)
                item.selected = item.selected ? 0 : 1;
            else
                item.selected = 0;
            temp.push(item)
        })
        setDocuments(temp)
    }

    const checkIfParticipated = () => {
        loadCourseParticipants().then(courseparticipants => {
            const list = asParticipantList(courseparticipants);
            setCourseParticipants(list)
            if (usertalent_id) {
                var courseparticipant = findParticipantForCourse(list, course_id)

                if (courseparticipant) {

                    setCourseParticipant(courseparticipant)
                }
            }
        })
    }

    const handleChange = (e) => {
        var value = e.target.value;
        setUserTalentId(value)

        getUserTalentDocuments(value);

        if (courseParticipants && value) {
            var courseparticipant = courseParticipants.find(x => x.course === course_id && x.usertalent == value)
            if (courseparticipant) {
                setCourseParticipant(courseparticipant)
            }
        }
        else {
            setCourseParticipant(null)
        }
    }



    const saveChanges = () => {
        // setRulesError("")
        setError(false)
        setLoading(false)

        if (!usertalent_id) {
            setError("Please select a talent")
            return
        }
        else {

            if (courseParticipant) {
                unroll(course, courseParticipant)
            }
            else {

                let selected_document = documents.find(x => x.selected === 1);
                if (!selected_document) {
                    setError(translate("Please select a document"))
                    return;
                }

                setContestParticipationModalIsOpen(true)


            }
        }
    }

    const handleVideoMounted = (element) => {
        if (element !== null && element) {
            element.currentTime = 5;
            //   if (!isNaN(element.duration)) setDuration(element.duration);
        }
    };



    const participate = () => {
        setRulesError("")
        setLoading(false)
        // if (!checked) {
        //     setRulesError(translate("Please accept terms and condititions"))
        //     return;
        // }
        let selected_document = documents.find(x => x.selected === 1);
        setLoading(translate("Please wait..."))
        addParticipantToCourse(course_id, usertalent_id, [selected_document.id]).then(data => {
            setError(false)
            setLoading(false)
            if (data.error) {
                window.location.reload()
                setRulesError(translate("You already participated in this competition"))

            }
            else if (data.Error) {
                setRulesError(translate("You cannot participate in this course again"))
            }
            else {
                setMessage(course_id)
                window.location.reload(false)
                checkIfParticipated()

            }

        })
    }
    return (
        <>
            <div className="lan-rtl mt-3 contest-participate__stack kfont">
                <div className="lan-text-right contest-participate__lead">
                    {courseParticipant
                        ? parse(translate("You already participated in this competition."))
                        : getDefaultDescription(course.names)}
                </div>

                {(!courseParticipant && !loading) && (
                    <div className="lan-text-right lan-rtl mt-2">
                        <div className="row margin-0">
                            {talent_document && (
                                <>
                                    <UserTalentDocumentUpload
                                        talent_id={talent_id}
                                        document_id={talent_document?.id}
                                        max_file_size={200 * 1024 * 1024}
                                        openModal={() => { }}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                )}

                {(courseDocument && !loading) && (
                    <div className="mt-3 lan-text-right">
                        {isImage(courseDocument) && (
                            <img
                                src={courseDocument}
                                className="img-fluid border-radius-0"
                                alt="You participated in the course with this document"
                            />
                        )}
                        {!isImage(courseDocument) && (
                            <video height="80">
                                <source src={courseDocument} type="video/mp4" />
                            </video>
                        )}
                    </div>
                )}

                {(documents && documents.length > 0 && !loading) && (
                    <div className="mt-3 lan-text-right">
                        <button
                            type="button"
                            onClick={() => {
                                saveChanges();
                            }}
                            data-toggle={courseParticipant && "modal"}
                            data-target={courseParticipant && "#deleteModal"}
                            className={
                                courseParticipant
                                    ? "btn newest-contest-banner__btn newest-contest-banner__btn--participating text-3 font-weight-bold"
                                    : "btn btn-primary rounded-35 font-weight-bold text-3 py-2 px-4"
                            }
                        >
                            {courseParticipant && (
                                <>
                                    <i
                                        className="fas fa-check-circle mr-2"
                                        aria-hidden="true"
                                    />
                                    {translate("You are participating")}
                                </>
                            )}
                            {!courseParticipant && !loading && (
                                <>
                                    <i className="fas fa-user-plus op-7"></i>&nbsp;
                                    {translate("Participate")}
                                </>
                            )}
                        </button>
                    </div>
                )}

                {error && (
                    <div className="alert alert-danger lan-rtl lan-text-right kfont mt-3">
                        {error}
                    </div>
                )}
            </div>

            <Modal
                closeTimeoutMS={500}
                isOpen={contestParticipationModalIsOpen}
                onRequestClose={() => {
                    setContestParticipationModalIsOpen(false);
                }}
                className="Modal "
                ariaHideApp={false}
                overlayClassName="Overlay"
            >
                <ContestParticipation
                    talentId={talent_id}
                    onSuccess={(courseParticipant) => {
                        setCourseParticipant(courseParticipant);
                        setContestParticipationModalIsOpen(false);
                    }}
                />
            </Modal>
        </>
    );
}
